module.exports = __webpack_public_path__ + "static/media/freezing_rain_light.3b8ee603.svg";